<template>
  <div>
    <v-container fluid grid-list-md>
      <progress-bar></progress-bar>
      <v-toolbar dark color="secondary" class="mb-4">
        <v-toolbar-title>
          Personal desk
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-layout row wrap>
        <v-flex xs12 sm6>
          <v-card>
            <v-card-title primary-title>
              <div class="headline">Workline</div>
            </v-card-title>
          </v-card>
          <div class="workline-group elevation-3">
            <v-card
                class="workline-group-item"
                v-for="(workline, index) in worklines"
                :key="index"
                :to="{ name: 'tasks-form', params: {project_id: workline.task.project_id, task_id: workline.task.id }}"
            >
              <v-card-text class="pa-1">
                <div class="tasks_page__list--item_chip">{{ workline.task.short_name.toUpperCase() }}</div>
                <span>{{ workline.task.title }}</span>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="py-1">
                <v-btn depressed small :color="workline.status == 'open' ? 'primary' : ''" @click.stop.prevent="changeStatus(workline, 'open')">
                  Open
                </v-btn>
                <v-btn depressed small :color="workline.status == 'postpone' ? 'primary' : ''" @click.stop.prevent="changeStatus(workline, 'postpone')">
                  Postponed
                </v-btn>
                <v-btn depressed small :color="workline.status == 'done' ? 'primary' : ''" @click.stop.prevent="changeStatus(workline, 'done')">
                  Finished
                </v-btn>
                <v-btn icon @click.stop.prevent="deleteWorkline(workline)">
                  <v-icon>delete</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="workline.task.instance_users && workline.task.instance_users.length"
                  v-for="user in workline.task.instance_users" :title="user.name"
                  icon
                  small
                  color="primary"
                >
                  {{ user.short_name }}
                </v-btn>
              </v-card-actions>
              <template
                v-if="workline.task.labels && workline.task.labels.length"
              >
                <v-divider></v-divider>
                <v-card-actions class="pa-1">
                  <div class="tasks_page__list--item_labels">
                    <div
                      v-for="label in workline.task.labels"
                      class="tasks_page__list--item_chip"
                      :style="{ color: label.text_color, 'background-color': label.color}"
                    >
                      {{ label.name }}
                    </div>
                  </div>
                </v-card-actions>
              </template>
            </v-card>
          </div>
        </v-flex>
        <v-flex xs12 sm6>
          <v-card>
            <v-card-title primary-title>
              <div class="headline">Payable Hours Overview</div>
            </v-card-title>
            <v-divider />
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 sm6 md3>
                  <v-menu v-model="menu" :return-value="filter.from" lazy transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filter.from"
                        label="Date"
                        v-on="on"
                        hide-details
                        outline
                        clearable
                      />
                    </template>
                    <v-date-picker
                      locale="ua-ua"
                      :first-day-of-week="1"
                      v-model="filter.from"
                      no-title
                      scrollable
                      min="2020-01-06"
                    />
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-menu v-model="menu2" :return-value="filter.to" lazy transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filter.to"
                        label="Date"
                        v-on="on"
                        outline
                        hide-details
                        clearable
                      />
                    </template>
                    <v-date-picker
                      locale="ua-ua"
                      :first-day-of-week="1"
                      v-model="filter.to"
                      no-title
                      scrollable
                      min="2020-01-06"
                    />
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-autocomplete
                    v-model="filter.projects"
                    :items="projects"
                    label="Projects"
                    item-text="name"
                    item-value="id"
                    multiple
                    hide-details
                    dense
                    small-chips
                    clearable
                    outline
                  />
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-btn
                    block
                    color="info"
                    class="ma-0"
                    style="height: 100%"
                    @click="getChart"
                    :loading="chartLoading"
                  >
                    Load
                  </v-btn>
                </v-flex>
              </v-layout>

              <div v-if="chartLoading" class="text-xs-center">
                <v-progress-circular indeterminate color="success"></v-progress-circular>
              </div>
              <template v-else>
                <transition name="fade">
                  <h3 v-if="!isChartVisible" class="text-xs-center">No data</h3>
                  <sl-chart
                    v-else
                    :chart-data="chartData"
                    :options="chartOptions"
                    type="PieChart"
                  ></sl-chart>
                </transition>
              </template>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import * as mixins from '@/mixins/'
  import chart from '@/components/reports/chart'
  import {mapGetters} from "vuex";

  export default {
    name: 'Dashboard',
    mixins: [mixins.filter, mixins.preloader, mixins.user],
    components: {
      'sl-chart': chart
    },
    data() {
      return {
        api: this.$api.tasks,
        view: 'list',
        worklines: [],
        projects: [],
        columns: [],
        data: [],
        menu: false,
        menu2: false,
        filter: {
          from: '',
          to: '',
          projects: []
        },
        originalChartData: {
          approved_for_payout: 0,
          logged: 0
        },
        activeSprintDates: {
          from:"",
          to:""
        },
        chartData: [
          ['Type', 'Hours', {type: 'string', role: 'tooltip'}],
        ],
        chartLoading: false
      }
    },
    computed: {
      ...mapGetters(['darkTheme']),
      chartOptions () {
        return {
          height: '400',
          pieSliceText: 'label',
          is3D: true,
          slices: [{ color: '#ff8f00' }, { color: '#1bc470' }],
          legend: {
            position: 'right',
            alignment: 'center',
            textStyle: { color: this.darkTheme ? '#fff' : '#000', fontSize: 16 }}
        }
      },
      isChartVisible() {
        return this.originalChartData.approved_for_payout || this.originalChartData.logged
      }
    },
    methods: {
      loadWorkline() {
        return this.$api.worklines.list({ unlimit: 1 }).then(response => {
          this.worklines = response.data.data ? response.data.data : response.data
        })
      },
      changeStatus(workline, status) {
        this.background(this.$api.worklines.changeStatus(workline.id, status).then(() => {
          this.loadWorkline()
        }))
      },
      deleteWorkline(workline) {
        this.background(this.$api.worklines.delete(workline.id).then(() => {
          this.loadWorkline()
        }))
      },
      loadColumns() {
        return this.$api.columns.list({unlimit: 1}).then(({data}) => {
          this.columns = data
        })
      },
      loadProjects() {
        return this.$api.projects.list({unlimit: 1}).then(({data}) => {
          this.projects = data
        })
      },
      load() {
        let params = {
          unlimit: 1,
          users: [this.getInstanceUserId()],
          ...this.collectFilter()
        }

        return this.api.list(params).then(({data}) => {
          this.data = this.columns.map(column => {
            return {
              ...column,
              tasks: data.filter(task => task.column_id == column.id)
            }
          })
        })
      },
      refresh() {
        this.background(this.load())
      },
      getCurrentSprintByDate(date = '') {
        return this.$api.reports.getSprintDates({ from: date, unlimit: 1 }).then(response => {
          this.filter.from = response.data.from
          this.filter.to = response.data.to
        }, (error) => {
          console.error(error)
        })
      },
      getChart() {
        this.chartLoading = true

        let params = {
          from: this.filter.from,
          to: this.filter.to,
          unlimit: 1,
          users: [this.user.id],
          projects: this.filter.projects
        }

        return this.$api.reports.getTimesChartData(params).then(response => {
          const keys = [
            { title: 'Logged', value: 'logged', humanPropertyName: 'logged_human' },
            { title: 'Approved for payout', value: 'approved_for_payout', humanPropertyName: 'approved_for_payout_human' }
          ]
          this.chartData = [['Type', 'Hours', {type: 'string', role: 'tooltip'}]]
          this.originalChartData = response.data

          keys.forEach(item => {
            this.chartData.push([
              `${item.title} - ${this.originalChartData[item.humanPropertyName]}`,
              response.data[item.value],
              `${item.title}: ${response.data[item.humanPropertyName]}`
            ])
          })
        }).finally(() => {
          this.chartLoading = false
        })
      },
      async refreshChart(date = '') {
        await this.getCurrentSprintByDate(date? date : null)
        this.getChart()
      }
    },
    mounted() {
      let preload = [this.loadProjects(), this.loadColumns(), this.loadWorkline(), this.getCurrentSprintByDate()]

      Promise.all(preload).then(() => {
        this.filter = {
          ...this.filter,
          ...this.$route.query,
          columns: [this.$route.query.columns].flat().filter(item => item).map(item => item && parseInt(item)),
          projects: [this.$route.query.projects].flat().filter(item => item).map(item => item && parseInt(item)),
        }

        this.load()
        this.getChart()
      })
    },
  }
</script>
